export const getAddonDataArr=(item)=>{
    let addonData=[]
    item?.addons?.map(i=>{
        i?.addon_items?.map(ai=>{
          if(ai?.selected==true){
            addonData.push({addon_id:ai?.addon_group_item_id,quantity:1})
          }
        })
      })
  
      item?.variations?.map(vi=>{
        vi?.variation_addon?.map(vai=>{
          vai?.addons?.map(vai=>{
            if(vai?.selected==true){
              addonData.push({addon_id:vai?.addon_group_item_id,quantity:1})
            }
          })
        })
      })
      return addonData
}